import firebase from 'firebase/app';

class Abstracts {
	getAbstracts() {
		return firebase
			.database()
			.ref(process.env.VUE_APP_FIREBASE_ABSTRACTS_COLLECTION + '/')
			.orderByChild('title');
	}
}

// Define as singleton
const instance = new Abstracts();
Object.freeze(instance);

export default instance;
